export const getProjID = () => {
  const unique_ID = getMsSinceMidnight(new Date());
  const dtStamp = new Date().toISOString().split("T")[0];
  return dtStamp + "-" + unique_ID;
};

function getMsSinceMidnight(d) {
  let e = new Date(d);
  return d - e.setHours(0, 0, 0, 0);
}

//this function gets a standard json bundle with key inside and then
//changes that to firebase type json, where key becomes an object Id.
//This function takes in a JSON object, but returns stringified version of correct json
//that can be used to do a PATCH in firebase
export const convert2FirebaseJson = projectBundle => {
  let fbJSON = {};
  const key = projectBundle.key;
  delete projectBundle[key];
  fbJSON[key] = {
    ...projectBundle
  };
  return JSON.stringify(fbJSON);
};

//this function does logging.
//Three levels of loggin
//FULL: If set to full, all types of logs will be generated, this
//      include state info, such as JSON objects
//DEBUG:If set to DEBUG, all info will logged except state info
//BASIC:If set to BASIC, only caugh exception will be logged
//this function probably later on can be switched to

export function logger(strLevel, methodName, logMessage) {
  //TODO
  //This const here to be take out or made dynamic
  //to check if running in dev then do logging else do not
  //do logging

  const DEBUG = "DEBUG";
  const FULL = "FULL";
  const BASIC = "BASIC";
  const settingLogLevel = "DEBUG";

  switch (settingLogLevel) {
    case FULL:
      {
        console.log(strLevel + " " + methodName + " " + logMessage);
      }
      return;
    case DEBUG:
      {
        if (strLevel === "DEBUG" || strLevel === "BASIC") {
          console.log(strLevel + " " + methodName + " " + logMessage);
        }
      }
      return;
    case BASIC:
      {
        if (strLevel === "BASIC") {
          console.log(
            "!!EXCEPTION!! " + strLevel + " " + methodName + " " + logMessage
          );
        }
      }
      return;
    default:
      if (strLevel === "BASIC") {
        console.log(
          "!!EXCEPTION!! " + strLevel + " " + methodName + " " + logMessage
        );
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/utils.js